// removed by extract-text-webpack-plugin
module.exports = {"modal-lg":"Modal__modal-lg","modalLg":"Modal__modal-lg","modal-fullscreen":"Modal__modal-fullscreen","modalFullscreen":"Modal__modal-fullscreen"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Modal/Modal.desktop.css
// module id = 506
// module chunks = 8